export const ConsentVersionMap = Object.freeze({
  MAY_2020: 'may-2020',
  JULY_2021: 'july-2021'
})

export const ConsentVersionAppMap = Object.freeze({
  'may-2020': '1.0.0',
  'july-2021': '1.0.1'
})

export const latestConsentVersion = ConsentVersionMap.JULY_2021
